<template>
    <div id="post" class="post-container col-lg-9 pt-4 pt-lg-0">
        <div v-if="post.status === DRAFT" class="alert alert-info alert-dismissible fade show mb-5" role="alert">
            <p class="mb-0">This post has not been published.</p>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div v-if="post.featured_image_public_path" class="post-img">
            <img :src="post.featured_image_public_path"/>
        </div>
        <div class="post-title">{{ post.title }}</div>
        <div class="post-date">Published: {{ post.published_at }}</div>
        <div id="post-viewer" ref="postViewer"></div>
        <Comments :post="post" :user="user" :postLikes="postLikes" :commentLikes="commentLikes" :comments="comments"/>
    </div>
</template>

<script>
import Quill from 'quill';
import Comments from '@/components/blog/Comments';

const PUBLISHED = 1;
const DRAFT = 2;

export default {
    components: {
        Comments
    },
    props: {
        post: {
            type: Object
        },
        user: {
            type: Object
        },
        postLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        commentLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        comments: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            DRAFT: DRAFT,
            PUBLISHED: PUBLISHED
        }
    },
    mounted() {
        this.editor = new Quill(this.$refs.postViewer, {
            readOnly: true,
            theme: false
        });

        if (this.post.content.length) {
            this.editor.setContents(JSON.parse(this.post.content), 'silent');
        }
    }
}
</script>
